import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_SIGNATURE_LINK } from "../signature-link.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateSignatureLinkInput } from "../../../__generated__/globalTypes";
import {
  CreateSignatureLinkMutation,
  CreateSignatureLinkMutationVariables,
} from "../../../__generated__/CreateSignatureLinkMutation";

interface IProps {
  defaultValues: DeepPartial<CreateSignatureLinkInput>;
  onCompleted: () => any;
}

export const useCreateSignatureLink = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateSignatureLinkInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateSignatureLinkMutation,
    CreateSignatureLinkMutationVariables
  >(CREATE_SIGNATURE_LINK, {
    refetchQueries: ["SignatureLinksQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createSignatureLink?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createSignatureLink?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
